import { gql } from "@apollo/client"
import { STANDARD_GRAPH_QUERY } from "../../../../services/ready-services/contentMgmnt/standards/standardsQueries"

export const GET_PUBLISHED_STANDARDS_GRAPH = gql`
  query getPublishedStandardsGraph($data: StandardV2Request!) {
    standardsV2 {
      getPublishedStandardsGraph(data: $data) {
        ${STANDARD_GRAPH_QUERY}
      }
    }
  }
`
